import { ApiServiceBase } from './ApiServiceBase'
import type { LocationQueryValue } from 'vue-router'

type Frequency = {
  posts: number
}

export default class extends ApiServiceBase {
  async show(): Promise<any> {
    return useAsyncData('frequency', () => this.call('/spa/frequency'))
  }

  async update(frequent: Frequency, regular: Frequency): Promise<any> {
    await this.call('/spa/frequency', {
      method: 'put',
      body: { frequent, regular },
    })
  }
}
